<template>
  <b-form-group>
    <label :class="{'required': required}"><slot/></label>
    <datepicker :value="value"
                :format="format"
                :placeholder="format"
                :typeable="true"
                :clearButton="true"
                :bootstrapStyling="true"
                :calendarButton="true"
                calendarButtonIcon="icon-calendar"
                :inputClass="addClass"
                @selected="$emit('input', $event)">
    </datepicker>
  </b-form-group>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'TextBox',
  props: {
    value: {
      type: Date
    },
    required: false,
    addClass: {
      type: Object
    }
  },
  data () {
    return {
      format: 'yyyy-MM-dd'
    }
  },
  components: {
    Datepicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/DatePicker.vue